import { PublicClientApplication, InteractionRequiredAuthError, type AccountInfo } from '@azure/msal-browser';

export const AUTH_MODE = (import.meta.env.VITE_AUTH_MODE ?? 'entra') as 'entra' | 'dev';
const API_SCOPE = import.meta.env.VITE_API_SCOPE as string;

export const msal = new PublicClientApplication({
  auth: {
    clientId: (import.meta.env.VITE_ENTRA_CLIENT_ID as string) || '00000000-0000-0000-0000-000000000000',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID as string}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: { cacheLocation: 'sessionStorage' },
});

export const loginRequest = { scopes: [API_SCOPE].filter(Boolean) };

export async function getToken(): Promise<string | null> {
  if (AUTH_MODE === 'dev') return null;
  const account: AccountInfo | null = msal.getActiveAccount() ?? msal.getAllAccounts()[0] ?? null;
  if (!account) return null;
  try {
    return (await msal.acquireTokenSilent({ ...loginRequest, account })).accessToken;
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) { await msal.acquireTokenRedirect({ ...loginRequest, account }); }
    throw e;
  }
}

// ---- Local development: pretend to be one of these people (never used in production builds with entra mode) ----
export const DEV_USERS = [
  { label: 'Director', oid: 'dev-director', upn: 'wayne@pti.edu.au', name: 'Wayne van Biljon', roles: ['Director'] },
  { label: 'RTO Manager', oid: 'dev-rtom', upn: 'sarah.mitchell@pti.edu.au', name: 'Sarah Mitchell', roles: ['RTOManager'] },
  { label: 'Admin Officer', oid: 'dev-admin', upn: 'priya.nair@pti.edu.au', name: 'Priya Nair', roles: ['AdminOfficer'] },
  { label: 'Employee', oid: 'dev-employee', upn: 'megan.walsh@pti.edu.au', name: 'Megan Walsh', roles: ['Employee'] },
];
export function devUser() {
  let i = 0;
  try { i = Number(localStorage.getItem('pti-dev-user') ?? 0); } catch { /* storage blocked */ }
  return DEV_USERS[i] ?? DEV_USERS[0]!;
}
export function setDevUser(i: number) { try { localStorage.setItem('pti-dev-user', String(i)); } catch { /* ignore */ } window.location.reload(); }
